export const CrossUseServiceKey = {
  ASUENE: 'asuene',
  ASUENE_CAREER: 'asuene-career',
  ASUENE_ESG_DATA: 'asuene-esg-data',
  ASUENE_LCA: 'asuene-lca',
  ASUENE_LCA_JA: 'asuene-lca-ja',
} as const

export type CrossUseServiceKeyType =
  (typeof CrossUseServiceKey)[keyof typeof CrossUseServiceKey]
